<ng-template #statusPagamento let-titulo="titulo" let-ativo="ativo" let-sub="sub" let-cancelar="cancelar">
  <div class="status-pag" aria-live="polite">
    <span class="status-icone">
      <span *ngIf="ativo" class="spin"></span>
      <svg *ngIf="!ativo" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 2.8 2.8L16 9.5"/></svg>
    </span>
    <div class="status-texto">
      <b>{{ titulo }}</b>
      <span *ngIf="sub">{{ sub }}</span>
      <span *ngIf="!sub && ativo">
        Conferimos sozinhos a cada {{ INTERVALO_VERIFICACAO_S }} s<ng-container *ngIf="segundosDesdeVerificacao !== null"> · última verificação há {{ segundosDesdeVerificacao }} s</ng-container>
      </span>
    </div>
    <button type="button" class="btn-verificar" [disabled]="verificandoPagamento" (click)="verificarPagamento()">
      <ng-container *ngIf="verificandoPagamento"><span class="spin spin-peq"></span> Verificando...</ng-container>
      <ng-container *ngIf="!verificandoPagamento">Já pagou? Verificar agora</ng-container>
    </button>
    <button *ngIf="cancelar" type="button" class="link link-neutro" (click)="cancelarEspera()">Cancelar</button>
  </div>
  <p *ngIf="avisoPagamento" class="texto-aviso">{{ avisoPagamento }}</p>
</ng-template>

<div class="corpo">
  <div class="abas" role="tablist" [style.grid-template-columns]="'repeat(' + abas.length + ', 1fr)'">
    <button *ngFor="let aba of abas" type="button" role="tab" class="aba" [class.ativa]="meio === aba"
            [attr.aria-selected]="meio === aba" [disabled]="abaBloqueada(aba)" (click)="escolherMeio(aba)">
      <ng-container [ngSwitch]="aba">
        <svg *ngSwitchCase="'maquininha'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="5" y="2.5" width="14" height="19" rx="2.5"/><path d="M8 7h8M8 11h8M9 15h.01M12 15h.01M15 15h.01M9 18h.01M12 18h.01M15 18h.01"/></svg>
        <svg *ngSwitchCase="'pix'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m12 3 4 4-4 4-4-4zM12 13l4 4-4 4-4-4zM3 12l4-4 4 4-4 4zM13 12l4-4 4 4-4 4z"/></svg>
        <svg *ngSwitchCase="'link'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1"/></svg>
        <svg *ngSwitchCase="'cartao'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M2.5 10h19M6 15h4"/></svg>
      </ng-container>
      {{ aba === 'maquininha' ? 'Maquininha' : aba === 'pix' ? 'PIX' : aba === 'link' ? 'Link de pagamento' : 'Digitar cartão' }}
      <small *ngIf="aba === 'pix' && !aceitaPix">só no anual</small>
    </button>
  </div>
  <ng-content></ng-content>

  <!-- Maquininha -->
  <section *ngIf="meio === 'maquininha'" class="painel">
    <div>
      <h3>Cobrar na maquininha</h3>
      <p class="sub">A cobrança vai para a maquininha do guichê; o paciente passa o cartão. Crédito à vista.</p>
    </div>

    <div class="campo">
      <label>Modelo</label>
      <div class="trilho">
        <button *ngFor="let m of MODELOS" type="button" class="segmento" [class.segmento-ativo]="modeloSelecionado === m"
                [attr.aria-pressed]="modeloSelecionado === m" [disabled]="statusCobranca === 'aguardando'"
                (click)="escolherModelo(m)">{{ m }}</button>
      </div>
    </div>

    <div class="maquina">
      <div class="campo">
        <label for="serial-maquininha">Número de série da maquininha</label>
        <div class="campo-serial" [class.campo-ok]="!!poiid" [class.campo-suspeito]="serialSuspeito">
          <input id="serial-maquininha" [value]="serial" (input)="onSerial($event)" inputmode="numeric"
                 placeholder="Série da maquininha" [disabled]="statusCobranca === 'aguardando'" />
          <span *ngIf="poiid" class="pill-ok">{{ modeloSelecionado }}</span>
        </div>
      </div>
      <button type="button" class="btn btn-primario" [disabled]="!poiid || isProcessando || statusCobranca === 'aguardando'"
              (click)="cobrarNaMaquininha()">
        {{ statusCobranca === 'aguardando' ? 'Enviado para a maquininha'
           : statusCobranca === 'falha' ? 'Tentar de novo'
           : isProcessando ? 'Enviando...'
           : 'Cobrar ' + (valor | brl) + (modeloSelecionado ? ' na ' + modeloSelecionado : '') }}
      </button>
    </div>

    <label class="lembrar">
      <input type="checkbox" [(ngModel)]="lembrar" /> Lembrar neste guichê
    </label>
    <div *ngIf="cacheSeriais.length" class="linha-chips">
      Em cache neste guichê:
      <button *ngFor="let c of cacheSeriais" type="button" class="chip" (click)="usarSerial(c.serial, c.modelo || '')">
        <b>{{ c.serial }}</b> {{ c.usadoEm | date: 'dd/MM HH:mm' }}
      </button>
      <button type="button" class="link" (click)="limparCache()">limpar</button>
    </div>
    <div *ngIf="sugestoesTerminal.length && statusCobranca !== 'aguardando'" class="linha-chips">
      Cadastradas:
      <button *ngFor="let t of sugestoesTerminal" type="button" class="chip" (click)="usarSerial(t.numero, t.tipo)">
        <b>{{ t.numero }}</b> {{ t.loja }}
      </button>
    </div>

    <ng-container *ngIf="statusCobranca === 'aguardando'"
      [ngTemplateOutlet]="statusPagamento"
      [ngTemplateOutletContext]="{ titulo: 'Aguardando o paciente na ' + modeloSelecionado, ativo: true, cancelar: true }"></ng-container>
    <div *ngIf="statusCobranca === 'falha'" class="falha">
      <b>Maquininha não respondeu</b>
      <span>Confira se a {{ modeloSelecionado || 'maquininha' }} está ligada e na rede, ou digite outra série.</span>
    </div>

    <ng-container *ngIf="cobrancaCriada && statusCobranca !== 'aguardando'"
      [ngTemplateOutlet]="statusPagamento"
      [ngTemplateOutletContext]="{ titulo: 'A cobrança já foi criada', ativo: false, sub: 'Se o paciente pagou, confira aqui.' }"></ng-container>
  </section>

  <!-- PIX -->
  <section *ngIf="meio === 'pix'" class="painel">
    <div>
      <h3>PIX</h3>
      <p class="sub">O paciente paga pelo QR na tela ou pelo link enviado por e-mail ou WhatsApp.</p>
    </div>
    <div *ngIf="!qrPix">
      <button type="button" class="btn btn-primario" [disabled]="isProcessando" (click)="gerarPix()">
        {{ isProcessando ? 'Gerando...' : 'Gerar PIX de ' + (valor | brl) }}
      </button>
    </div>
    <ng-container *ngIf="qrPix">
      <ng-container [ngTemplateOutlet]="statusPagamento"
        [ngTemplateOutletContext]="{ titulo: 'Aguardando o pagamento do PIX', ativo: true }"></ng-container>
      <div class="resultado">
        <img class="qr" [src]="qrPix" alt="QR do PIX" />
        <div class="linkbox">
          <b>Mostre o QR ou envie o link</b>
          <div *ngIf="podeEnviarLink" class="acoes">
            <button type="button" class="btn btn-secundario" [disabled]="isEnviandoLink" (click)="enviarLink(true, false)">Enviar por e-mail</button>
            <button type="button" class="btn btn-secundario" [disabled]="isEnviandoLink" (click)="enviarLink(false, true)">Enviar por WhatsApp</button>
          </div>
          <p *ngFor="let a of avisosLink" class="texto-aviso">{{ a }}</p>
        </div>
      </div>
    </ng-container>
  </section>

  <!-- Link de pagamento: o paciente digita o cartão no checkout -->
  <section *ngIf="meio === 'link'" class="painel">
    <div>
      <h3>Link de pagamento</h3>
      <p class="sub">O paciente abre no celular e paga com cartão de crédito. Confira o contato antes de enviar.</p>
    </div>
    <div *ngIf="!checkoutLiberado" class="alerta">
      Disponível com o termo assinado e o paciente cadastrado no CartãoSiM.
    </div>

    <div class="contatos">
      <div *ngFor="let canal of canaisCheckout" class="contato">
        <div class="icone" aria-hidden="true">
          <svg *ngIf="canal === 'whatsapp'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.5 11.5a8.5 8.5 0 0 1-12.6 7.4L3.5 20l1.2-4.2A8.5 8.5 0 1 1 20.5 11.5Z"/></svg>
          <svg *ngIf="canal === 'email'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6 8.5-6"/></svg>
        </div>
        <ng-container *ngIf="editandoCheckout !== canal">
          <div class="info">
            <b>{{ canal === 'whatsapp' ? 'WhatsApp' : 'E-mail' }}</b>
            <span>{{ destinoCheckout(canal) || (canal === 'whatsapp' ? 'Sem celular no cadastro' : 'Sem e-mail no cadastro') }}</span>
          </div>
          <button type="button" class="link" [disabled]="isGerandoCheckout" (click)="editarContatoCheckout(canal)">Editar</button>
          <button type="button" class="btn btn-secundario" [disabled]="isGerandoCheckout || !checkoutLiberado || !destinoCheckout(canal)"
                  (click)="enviarCheckout(canal)">Enviar</button>
        </ng-container>
        <ng-container *ngIf="editandoCheckout === canal">
          <div class="info edicao">
            <b>{{ canal === 'whatsapp' ? 'WhatsApp' : 'E-mail' }}</b>
            <input class="entrada" [(ngModel)]="valorEdicaoCheckout"
                   [attr.inputmode]="canal === 'whatsapp' ? 'numeric' : 'email'"
                   [placeholder]="canal === 'whatsapp' ? 'DDD + celular' : 'e-mail do paciente'"
                   [attr.aria-label]="canal === 'whatsapp' ? 'Celular para o WhatsApp' : 'E-mail'"
                   (keyup.enter)="salvarContatoCheckout()" />
            <span *ngIf="erroEdicaoCheckout" class="texto-erro">{{ erroEdicaoCheckout }}</span>
          </div>
          <button type="button" class="link link-neutro" (click)="cancelarContatoCheckout()">Cancelar</button>
          <button type="button" class="btn btn-secundario" (click)="salvarContatoCheckout()">Salvar</button>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="avisoCheckout" [ngTemplateOutlet]="statusPagamento"
      [ngTemplateOutletContext]="{ titulo: avisoCheckout, ativo: true }"></ng-container>

    <div class="resultado">
      <img *ngIf="qrCheckout" class="qr" [src]="qrCheckout" alt="QR do link de pagamento" />
      <div class="linkbox">
        <b>{{ linkCheckout ? 'Ou mostre o QR / copie o link' : 'Prefere mostrar o QR ou copiar o link?' }}</b>
        <input *ngIf="linkCheckout" class="entrada" [value]="linkCheckout" readonly aria-label="Link de pagamento"
               (focus)="$any($event.target).select()" />
        <div class="acoes">
          <button type="button" class="btn btn-secundario" [disabled]="isGerandoCheckout || !checkoutLiberado" (click)="copiarLinkCheckout()">
            {{ isGerandoCheckout ? 'Gerando...' : 'Copiar link' }}
          </button>
          <span *ngIf="avisoCopia" class="nota">{{ avisoCopia }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Digitar cartão: número, validade e CVV são iframes da Adyen -->
  <section *ngIf="meio === 'cartao'" class="painel">
    <div>
      <h3>Digitar o cartão do paciente</h3>
      <p class="sub">Preencha com o cartão em mãos. Os dados são criptografados pela Adyen; a Fila não vê nem guarda o número.</p>
    </div>
    <div *ngIf="!checkoutLiberado" class="alerta">
      Disponível com o termo assinado e o paciente cadastrado no CartãoSiM.
    </div>

    <div #cartaoContainer class="campos" [class.carregando]="carregandoCartao">
      <div class="campo cheio">
        <label>Número do cartão</label>
        <span class="seguro" data-cse="encryptedCardNumber"></span>
      </div>
      <div class="campo">
        <label>Validade</label>
        <span class="seguro" data-cse="encryptedExpiryDate"></span>
      </div>
      <div class="campo">
        <label>CVV</label>
        <span class="seguro" data-cse="encryptedSecurityCode"></span>
      </div>
      <div class="campo cheio">
        <label for="nome-cartao">Nome impresso no cartão</label>
        <input id="nome-cartao" class="entrada alta" [(ngModel)]="nomeCartao" placeholder="Como está no cartão"
               autocomplete="off" [disabled]="aguardandoCartao" />
      </div>
      <div class="campo">
        <label for="bandeira-cartao">Bandeira</label>
        <select id="bandeira-cartao" class="entrada alta" [class.campo-ok]="bandeiraIdentificada"
                [class.campo-suspeito]="cartaoValido && !bandeiraCartao"
                [ngModel]="bandeiraCartao" (ngModelChange)="escolherBandeira($event)" [disabled]="aguardandoCartao">
          <option value="" disabled>Selecione</option>
          <option *ngFor="let b of bandeirasAceitas" [value]="b.codigo">{{ b.nome }}</option>
        </select>
        <span *ngIf="bandeiraIdentificada" class="dica-bandeira ok">Identificada pelo número</span>
        <span *ngIf="cartaoValido && !bandeiraCartao" class="dica-bandeira atencao">
          Não identificamos a bandeira, selecione
        </span>
      </div>
      <div class="campo">
        <label for="parcelas-cartao">Parcelas</label>
        <select id="parcelas-cartao" class="entrada alta" [(ngModel)]="parcelasCartao"
                [disabled]="aguardandoCartao || opcoesParcelas.length === 1">
          <option *ngFor="let p of opcoesParcelas" [ngValue]="p.n">{{ p.n }}x de {{ p.valor | brl }}</option>
        </select>
      </div>
    </div>

    <div class="cadeado">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>
      Pagamento protegido pela Adyen
    </div>
    <div class="alerta">Cartão não presente: confirme que o titular está no guichê e autoriza a cobrança.</div>

    <ng-container *ngIf="aguardandoCartao" [ngTemplateOutlet]="statusPagamento"
      [ngTemplateOutletContext]="{ titulo: avisoCartao, ativo: true }"></ng-container>
    <ng-container *ngIf="cartaoEnviado && !aguardandoCartao" [ngTemplateOutlet]="statusPagamento"
      [ngTemplateOutletContext]="{ titulo: 'O pagamento já foi enviado', ativo: false, sub: 'Se o cartão foi aprovado, confira aqui.' }"></ng-container>

    <button type="button" class="btn btn-primario btn-grande" [disabled]="!podePagarCartao" (click)="pagarCartao()">
      {{ isPagandoCartao ? 'Enviando...' : aguardandoCartao ? 'Aguardando a aprovação' : 'Pagar ' + (valor | brl) }}
    </button>
  </section>

  <p *ngIf="erro" class="texto-erro" role="alert">{{ erro }}</p>
</div>

<div class="rodape">
  <span>{{ rodape }}</span>
  <button type="button" class="link link-neutro" [disabled]="statusCobranca === 'aguardando' || aguardandoCartao" (click)="voltar.emit()">Voltar</button>
</div>
